export default {"src":"/_next/static/media/home-menu-home-active-new.bd953f08.svg","height":14,"width":14};